import { render, staticRenderFns } from "./PlainLeads.vue?vue&type=template&id=c8ffa462&"
import script from "./PlainLeads.vue?vue&type=script&lang=js&"
export * from "./PlainLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports